module.exports = __webpack_public_path__ + "static/class-notes-749e4f89323970cba2f58982bf53ffd0.jpg";